import leaf from "../Assets/Services/web-development.png";
import emotion from "../Assets/Services/project-managment.png";
import editor from "../Assets/Services/seo-word.png";
import chatify from "../Assets/Services/UI-UX.png";
import suicide from "../Assets/Services/database-managment.png";
import bitsOfCode from "../Assets/Services/web-design.png";

const servicesData = [
  {
    imgPath: leaf, 
    title: "Web Development",
    description: "Create dynamic, responsive websites and web applications tailored to your business needs. Our web development services include front-end, back-end, and full-stack solutions.",
    bookLink: "https://www.linkedin.com/services/page/62893231b7588b3145/request-proposal/",
    bookMeeting: "https://yourwebsite.com/learn-more"
  },
  {
    imgPath: emotion, 
    title: "Project Management",
    description: "Expert project management to ensure your IT projects are delivered on time and within budget. We use proven methodologies to manage scope, resources, and risks.",
    bookLink: "https://www.linkedin.com/services/page/62893231b7588b3145/request-proposal/",
    bookMeeting: "https://yourwebsite.com/learn-more"
  },
  {
    imgPath: editor, 
    title: "Search Engine Optimization (SEO)",
    description: "Optimize your website to rank higher in search engine results. Our SEO services include keyword research, on-page optimization, and link building to increase your online visibility.",
    bookLink: "https://www.linkedin.com/services/page/62893231b7588b3145/request-proposal/",
    bookMeeting: "https://yourwebsite.com/learn-more"
  },
  {
    imgPath: chatify, 
    title: "Mobile Application Development",
    description: "Develop custom software applications that meet your specific business requirements. We handle everything from concept to deployment, including mobile and desktop applications.",
    bookLink: "https://www.linkedin.com/services/page/62893231b7588b3145/request-proposal/",
    bookMeeting: "https://yourwebsite.com/learn-more"
  },
  {
    imgPath: suicide, 
    title: "Database Development",
    description: "Design and implement robust database solutions for efficient data storage and management. Our database development services include schema design, optimization, and integration.",
    bookLink: "https://www.linkedin.com/services/page/62893231b7588b3145/request-proposal/",
    bookMeeting: "https://yourwebsite.com/learn-more"
  },
  
  {
    imgPath: bitsOfCode, 
    title: "User Experience Design (UED)",
    description: "Enhance the usability and satisfaction of your digital products through expert UX design. We focus on creating intuitive, user-friendly interfaces that improve engagement and conversion rates.",
    bookLink: "https://www.linkedin.com/services/page/62893231b7588b3145/request-proposal/",
    bookMeeting: "https://yourwebsite.com/learn-more"
  },
  {
    imgPath: editor, 
    title: "Technical Support",
    description: "Provide ongoing technical support to ensure your IT systems run smoothly. Our support services include troubleshooting, maintenance, and updates to keep your technology up-to-date.",
    bookLink: "https://www.linkedin.com/services/page/62893231b7588b3145/request-proposal/",
    bookMeeting: "https://yourwebsite.com/learn-more"
  },
  {
    imgPath: chatify, 
    title: "Web Design",
    description: "Craft visually appealing and functional web designs that capture your brand’s essence. We create custom designs that align with your business goals and enhance user experience.",
    bookLink: "https://www.linkedin.com/services/page/62893231b7588b3145/request-proposal/",
    bookMeeting: "https://yourwebsite.com/learn-more"
  },
  {
    imgPath: leaf, 
    title: "Blogging",
    description: "Create and manage engaging content for your blog to attract and retain your target audience. Our blogging services include content creation, SEO, and performance tracking.",
    bookLink: "https://www.linkedin.com/services/page/62893231b7588b3145/request-proposal/",
    bookMeeting: "https://yourwebsite.com/learn-more"
  }
];

export default servicesData;
